import Tables from "../../../../components/Tables/Tables";
import Modal from "../../../../components/Modal/Modal";
import Modal2 from "../../../../components/Modal/Modal";
import Input from "../../../../components/Input/Input.jsx";
import Toast from "../../../../components/Toast/Toast";
import CustomButton from "../../../../components/Button/CustomButton.tsx";
import Print from "../../../../assets/Icons/Buttons/Muestras/Print.svg";
import More from "../../../../assets/Icons/Buttons/More.svg";
import Preloader from "../../../../components/Preloader/Preloader.jsx";
import SetIcon from "../../../../assets/Icons/Buttons/Clientes/SetIcon.svg";
import RenderImg from "../../../../components/RenderImg/RenderImg.tsx";
import CustomRow from "../../../../components/CustomRow/CustomRow.tsx";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { Search } from "@mui/icons-material";
import { buttonsMuestras } from "../../../../components/ButtonsTable/ButtonsTable";
import {
  StyledTypography,
  Styled,
  BoxHeader,
  BoxInputs,
  BoxSubHeader,
} from "./MuestrasStyled";
import { RenderImgStyled } from "../../../Task/Items/SuperAdminStyled";
import {
  getClienteOptions,
  getPlantabyCliente2,
  getPlantaOptions,
  imprimirMuestras,
  imprimirResumen,
} from "../../../../api/Clientes";
import {
  getMuestrasNewFilters,
  getAllOrdenByClienteOptions,

  deleteMuestra,
} from "../../../../api/Muestras.js";
import {
  getPlantaOptionsMuestras,
  getAllOrdenTrabajoOptionsMuestras,
  getAllEquipoOptionsMuestras,
  getAllOrdenByClienteOptionsMuestras,
  getAllEquipoByClienteOptionsMuestras
} from "../../../../api/Muestras.ts";
import { getEquipoOptionsMuestras } from "../../../../api/EndPoints.ts"
import { useAuth } from "../../../../context/AuthContext.jsx";
import { fonts, colors } from "../../../../assets/styles/theme.ts";
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "nroMuestra", label: "Nro.Muestra" },
  { id: "equipo", label: "Equipo" },
  { id: "fechaAnalisis", label: "Fecha Análisis" },
  { id: "conjAnalisis", label: "Conj. Análisis" },
  { id: "estadoFinal", label: "Estado Final" },
  { id: "planta", label: "Planta" },
  { id: "estado", label: "Estado" },
  { id: "buttons" },
];

// Debounce utility function
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

// Cache for API responses
const apiCache = new Map();

const datosCheckBox = [
  {
    label: "Sin Diagnóstico",
    name: "sinDiagnostico",
  },
  {
    label: "Sin Estado",
    name: "sinEstado",
  },
  {
    label: "Sin Fecha Análisis",
    name: "sinFechaAnalisis",
  },
  {
    label: "Sin Imágenes",
    name: "sinImagenes"
  },
  {
    label: "Sin Resultados",
    name: "sinResultados"
  },
  {
    label: "Sin Sugerencias",
    name: "sinSugerencias"
  },
];

const Muestras = () => {
  const location = useLocation();
  const datos = location.state;
  const navigate = useNavigate();
  const { token } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();

  const idCli = searchParams.get('idcli');
  const idPla = searchParams.get('idpla');
  const idOt = searchParams.get('idot');
  const idEqui = searchParams.get('ideq');

  const [isLoading, setIsLoading] = useState(idCli ? true : false);
  const [statusModal, setModalStatus] = useState(false);
  const [statusModal2, setModalStatus2] = useState(false);
  const [muestraId, setMuestraId] = useState("");
  const [datosModal, setDatosModal] = useState("");
  const [typeModal, setTypeModal] = useState("muestras");
  const [searchTerm, setSearchTerm] = useState("");
  const [muestras, setMuestras] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [itemsCount, setItemsCount] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [clientes, setClientes] = useState([]);
  const [selectedOptionCli, setSelectedOptionCli] = useState(null);
  const [plantas, setPlantas] = useState([]);
  const [selectedOptionPla, setSelectedOptionPla] = useState(null);
  const [ordenTrabajo, setOrdenTrabajo] = useState([]);
  const [selectedOptionOt, setSelectedOptionOt] = useState([]);
  const [equipo, setEquipo] = useState([]);
  const [selectedOptionEquipo, setSelectedOptionEquipo] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [key, setKey] = useState(0);
  const [sinDiagnostico, setSinDiagnostico] = useState(searchParams.get('sd') === 'true' || false);
  const [sinEstado, setSinEstado] = useState(searchParams.get('se') === 'true' || false);
  const [sinFechaAnalisis, setSinFechaAnalisis] = useState(searchParams.get('sf') === 'true' || false);
  const [sinImagenes, setSinImagenes] = useState(searchParams.get('si') === 'true' || false);
  const [sinResultados, setSinResultados] = useState(searchParams.get('sr') === 'true' || false);
  const [sinSugerencias, setSinSugerencias] = useState(searchParams.get('ss') === 'true' || false);
  const [muestrasIds, setMuestrasIds] = useState([]);
  const lastRequestId = useRef(0);


  // Debounced search term to reduce API calls
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  // Memoized filter values to prevent unnecessary re-renders
  const filterValues = useMemo(() => ({
    cliente: selectedOptionCli?.value || "",
    planta: selectedOptionPla?.value || "",
    ordenTrabajo: selectedOptionOt?.value || "",
    equipo: selectedOptionEquipo?.value || "",
    sinDiagnostico,
    sinEstado,
    sinFechaAnalisis,
    sinImagenes,
    sinResultados,
    sinSugerencias
  }), [
    selectedOptionCli?.value,
    selectedOptionPla?.value,
    selectedOptionOt?.value,
    selectedOptionEquipo?.value,
    sinDiagnostico,
    sinEstado,
    sinFechaAnalisis,
    sinImagenes,
    sinResultados,
    sinSugerencias
  ]);



  useEffect(() => {

    const cargarDatosPorPlanta = async () => {
      try {
        const plantaId = selectedOptionPla?.value;
        const cacheKey = `planta_${plantaId || 'all'}`;

        if (apiCache.has(cacheKey)) {
          const cachedData = apiCache.get(cacheKey);
          setOrdenTrabajo(cachedData.ordenes);
          setEquipo(cachedData.equipos);
          setSelectedOptionOt(null);
          setSelectedOptionEquipo(null);
          return;
        }

        if (plantaId) {
          const [ordenesRes, equiposRes] = await Promise.all([
            getAllOrdenByClienteOptionsMuestras(plantaId),
            getAllEquipoByClienteOptionsMuestras(plantaId),
          ]);

          const nuevasOrdenes = ordenesRes.data.map((ot) => ({
            value: ot.id,
            label: `${ot.desc_otra} #${ot.nro_lote_otra}`,
            subLabel: ot.estado.desc_ef_ot,
            code: ot.codigo_otra,
            color: ot.estado.color_ef_ot
          }));
          setOrdenTrabajo(nuevasOrdenes);

          const nuevosEquipos = equiposRes.data.map((eq) => ({
            label: eq.desc_equi,
            value: eq.id,
            code: eq.codigo_equi
          }));
          setEquipo(nuevosEquipos);

          // Cache the results
          apiCache.set(cacheKey, {
            ordenes: nuevasOrdenes,
            equipos: nuevosEquipos
          });
        } else {
          const [ordenesRes, equiposRes] = await Promise.all([
            getAllOrdenByClienteOptionsMuestras(plantaId),
            getAllEquipoByClienteOptionsMuestras(plantaId),
          ]);

          const nuevasOrdenes = ordenesRes.data.map((ot) => ({
            value: ot.id,
            label: `${ot.desc_otra} #${ot.nro_lote_otra}`,
            subLabel: ot.estado.desc_ef_ot,
            code: ot.codigo_otra,
            color: ot.estado.color_ef_ot
          }));
          setOrdenTrabajo(nuevasOrdenes);

          const nuevosEquipos = equiposRes.data.map((eq) => ({
            label: eq.desc_equi,
            value: eq.id,
            code: eq.codigo_equi
          }));
          setEquipo(nuevosEquipos);

          // Cache the results
          apiCache.set(cacheKey, {
            ordenes: nuevasOrdenes,
            equipos: nuevosEquipos
          });
        }

        setSelectedOptionOt(null);
        setSelectedOptionEquipo(null);

      } catch (error) {
        console.error(error);
      }
    };

    // if (token?.rol !== "TENANT") {
    //   cargarDatosPorPlanta();
    // }
    cargarDatosPorPlanta();
  }, [selectedOptionPla, token?.rol]);

  useEffect(() => {
    const cargarDatosIniciales = async () => {
      try {
        // Check cache for clientes
        if (apiCache.has('clientes')) {
          const cachedClientes = apiCache.get('clientes');
          setClientes(cachedClientes);
        } else {
          const clientesRes = await getClienteOptions();
          const nuevosClientes = clientesRes.data.map((cli) => ({
            label: cli.desc_cli,
            value: cli.id
          }));
          setClientes(nuevosClientes);
          apiCache.set('clientes', nuevosClientes);
        }

        const clienteId = idCli || token.clienteId;
        const clientesData = apiCache.get('clientes') || [];
        const cliente = clientesData.find(c => c.value === parseInt(clienteId, 10));

        if (!cliente) return;

        setSelectedOptionCli({ label: cliente.label, value: cliente.value });

        // Check cache for planta data
        const plantaCacheKey = `planta_cliente_${cliente.value}`;
        if (apiCache.has(plantaCacheKey)) {
          const cachedData = apiCache.get(plantaCacheKey);
          setPlantas(cachedData.plantas);
          setOrdenTrabajo(cachedData.ordenes);
          setEquipo(cachedData.equipos);
        } else {
          const [plantasRes, ordenesRes, equiposRes] = await Promise.all([
            getPlantaOptionsMuestras(),
            getAllOrdenTrabajoOptionsMuestras(cliente.value),
            getEquipoOptionsMuestras(cliente.value)
          ]);


          const nuevasPlantas = plantasRes.data.map((pla) => ({
            label: pla.desc_pla,
            subLabel: pla.cliente.description,
            value: pla.id
          }));
          setPlantas(nuevasPlantas);

          const nuevasOrdenes = ordenesRes.data.map((ot) => ({
            value: ot.id,
            label: `${ot.desc_otra} #${ot.nro_lote_otra}`,
            subLabel: ot.estado.desc_ef_ot,
            code: ot.codigo_otra,
            color: ot.estado.color_ef_ot
          }));
          setOrdenTrabajo(nuevasOrdenes);

          const nuevosEquipos = equiposRes.data.map((eq) => ({
            label: eq.desc_equi,
            value: eq.id,
            code: eq.codigo_equi
          }));
          setEquipo(nuevosEquipos);



          // Cache the results
          apiCache.set(plantaCacheKey, {
            plantas: nuevasPlantas,
            ordenes: nuevasOrdenes,
            equipos: nuevosEquipos
          });

        }

      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      } finally {
        setIsLoading(false);
      }
    };

    cargarDatosIniciales();
  }, [idCli, token]);

  useEffect(() => {
    if (isLoading) return;

    fetchMuestrasAllFilters(
      paginaActual,
      orderBy,
      debouncedSearchTerm, // Use debounced search term instead of searchTerm
      "inicial",
      filterValues.cliente,
      filterValues.planta,
      filterValues.ordenTrabajo,
      filterValues.equipo,
      filterValues.sinDiagnostico,
      filterValues.sinEstado,
      filterValues.sinFechaAnalisis,
      filterValues.sinImagenes,
      filterValues.sinResultados,
      filterValues.sinSugerencias
    );
  }, [
    isLoading,
    paginaActual,
    orderBy,
    debouncedSearchTerm, // Only trigger on debounced search term
    filterValues // Use memoized filter values
  ]);



  useEffect(() => {
    if (!isLoading && idPla && plantas.length > 0) {
      const plantaSel = plantas.find((p) => p.value === parseInt(idPla, 10));
      if (plantaSel) setSelectedOptionPla(plantaSel);
    }

    if (!isLoading && idOt && ordenTrabajo.length > 0) {
      const otSel = ordenTrabajo.find((o) => o.value === parseInt(idOt, 10));
      if (otSel) setSelectedOptionOt(otSel);
    }

    if (!isLoading && idEqui && equipo.length > 0) {
      const eqSel = equipo.find((e) => e.value === parseInt(idEqui, 10));
      if (eqSel) setSelectedOptionEquipo(eqSel);
    }
  }, [plantas, ordenTrabajo, equipo, idPla, idOt, idEqui, isLoading]);



  const fetchMuestrasAllFilters = useCallback(async (
    pagina,
    order,
    search,
    action,
    idCli = "",
    idPla = "",
    idOt = "",
    idEqui = "",
    sindiagnostico = false,
    sinestado = false,
    sinfechaAnalisis = false,
    sinimagenes = false,
    sinresultados = false,
    sinsugerencias = false
  ) => {
    const requestId = ++lastRequestId.current;

    try {
      const res = await getMuestrasNewFilters(
        idCli,
        idPla,
        idOt,
        idEqui,
        pagina,
        order,
        search,
        sindiagnostico,
        sinestado,
        sinfechaAnalisis,
        sinimagenes,
        sinresultados,
        sinsugerencias
      );

      if (requestId !== lastRequestId.current) return;

      setPageCount(res.data.totalPages);
      setItemsCount(res.data.totalItems);

      if (action === "new") {
        
      } else if (action === "delete") {
        setKey((prev) => prev + 1);
        setMsjToast("Muestra eliminada con exito.");
        setSuccess(true);
      } else {
        if (res.data.totalPages === 0) {
          setPaginaActual(1);
        } else if (res.data.totalPages < pagina) {
          setPaginaActual(res.data.totalPages);
        } else {
          setPaginaActual(pagina);
        }
      }

      setMuestrasIds(res.data.filteredIds);

      const nuevosDatos = res.data.items.map((res) => {
        const fechaFormateada = res?.fecha_analisis_mue
          ? moment(res.fecha_analisis_mue).isValid()
            ? moment(res.fecha_analisis_mue).format("DD/MM/YYYY")
            : ""
          : "";

        return {
          fechaProgr: fechaFormateada,
          codigo: res.codigo_mue,
          denominacion: res.desc_mue,
          cliente: res.cliente.desc_cli,
          clienteDesc: res.cliente.desc_cli,
          planta: res.planta.description,
          estado: res.estado_mue,
          id: res.id,
          horasUso: res.horas_equipo_mue,
          horasUsoLubricante: res.horas_lubricante_mue,
          responsable: res.responsable_toma_mue,
          punto: res.punto_toma.description,
          ordenTrabajo: res.orden_trabajo,
          puntoToma: res.punto_toma,
          conjunto: res.conjunto_analisis,
          lubricante: res.lubricante,
          fechaTomaMue: res.fecha_toma_mue,
          estadoFinal: (
            <CustomRow
              label={res?.estado_final?.desc_efm ?? ""}
              colorBorder={res?.estado_final?.color_efm}
              svg={res?.estado_final?.imagen_efm}
            />
          ),
          conjAnalisis: res?.conjunto_analisis?.description,
          equipo: res?.equipo?.description,
          nroMuestra: res?.codigo_mue,
          causafalla: res?.causa_falla,
          fechaAnalisis: fechaFormateada
        };
      });

      setMuestras(nuevosDatos);
    } catch (error) {
      console.error("Error fetching muestras:", error);
      if (requestId === lastRequestId.current) {
        setError(true);
        setMsjToast("Error al cargar las muestras");
      }
    }
  }, []);

  const handleImprimirResumen = () => {
    const bodyImprimir = muestrasIds;

    imprimirResumen(bodyImprimir)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "resumen.pdf"); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      });
  };

  const handleImprimirMuestras = () => {
    const bodyImprimir = muestrasIds;

    imprimirMuestras(bodyImprimir)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "muestras.pdf"); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      });
  };

  const handleImprimirMuestraEspecifica = (id, codigo) => {


    const bodyImprimir = id;

    imprimirMuestras(bodyImprimir)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "muestra-" + codigo + ".pdf"); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      });
  };

  const handleClickButtonTable = (value, valueRow) => {
    const val = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    if (value === "crear") {
      setModalStatus(true);
      setTypeModal("muestras");
      setDatosModal("");
    }
    if (value === "editar") {
      // console.log("entre2");
      setModalStatus(true);
      setTypeModal("editar");
      setDatosModal(valueRow);
    }
    if (val !== "eliminar" && val !== "diagnostico") {
      setModalStatus(true);
      setTypeModal("muestras");
      setDatosModal({ button: value.toLowerCase(), datos: valueRow });
    }
    if (val === "diagnostico") {
      setModalStatus(true);
      setTypeModal("diagMuestras");
      setDatosModal({ button: value.toLowerCase(), datos: valueRow });
    }
    if (val === "eliminar") {
      setMuestraId(valueRow.id);
      setModalStatus2(true);
    }
  };

  const handleClickButtonHeader = (e) => {
    setDatosModal("");
    setTypeModal("muestras");
    setModalStatus(true);
  };

  const handleOrder = (value) => {
    let valor;
    switch (value) {
      case "Nro.Muestra":
        value = "Código";
        break;
      case "Equipo":
        value = "Equipo";
        break;
      case "Fecha Análisis":
        value = "Fecha Análisis";
        break;
      case "Conj. Análisis":
        value = "Conjunto Análisis";
        break;
      case "Estado Final":
        value = "Estado Final Desc";
        break;
      case "Cliente":
        value = "Cliente";
        break;
      case "Estado":
        value = "Estado";
        break;
      default:
        break;
    }
    if (orderBy === "" || orderBy.replace("-", "").length !== value.length) {
      valor = value;
    } else {
      valor = orderBy;
    }

    if (valor.indexOf("-") > -1) {
      const updatedValue = valor.replace("-", "");
      setOrderBy(updatedValue);
    } else {
      const updatedValue = "-" + valor;
      setOrderBy(updatedValue);
    }
  };

  const handleChangeCliente = useCallback((value) => {
    setSelectedOptionCli(!value ? null : value);
    setSelectedOptionPla(null);
    setPlantas([]);
    setSelectedOptionOt(null);
    setOrdenTrabajo([]);
    setSelectedOptionEquipo(null);
    setEquipo([]);

    if (value !== null) {

      // Check cache first
      const cacheKey = `cliente_${value.value}`;
      if (apiCache.has(cacheKey)) {
        const cachedData = apiCache.get(cacheKey);
        setPlantas(cachedData.plantas);
        setOrdenTrabajo(cachedData.ordenes);
        setEquipo(cachedData.equipos);
        return;
      }

      // Fetch and cache data
      Promise.all([
        getPlantabyCliente2(value.value),
        getAllOrdenByClienteOptions(value.value),
        getEquipoOptionsMuestras(value.value)
      ]).then(([plantasRes, ordenesRes, equiposRes]) => {
        const nuevasPlantas = plantasRes.data.map((res) => ({
          label: res.desc_pla,
          subLabel: res.cliente.description,
          value: res.id
        }));
        setPlantas(nuevasPlantas);

        const nuevasOrdenes = ordenesRes.data.map((res) => ({
          value: res.id,
          label: `${res.desc_otra} #${res.nro_lote_otra}`,
          subLabel: res.estado.desc_ef_ot,
          code: res.codigo_otra,
          color: res.estado.color_ef_ot
        }));
        setOrdenTrabajo(nuevasOrdenes);

        const nuevosEquipos = equiposRes.data.map((res) => ({
          label: res.desc_equi, value: res.id, code: res.codigo_equi
        }));
        setEquipo(nuevosEquipos);

        // Cache the results
        apiCache.set(cacheKey, {
          plantas: nuevasPlantas,
          ordenes: nuevasOrdenes,
          equipos: nuevosEquipos
        });
      }).catch(error => {
        console.error("Error loading cliente data:", error);

      });
    }
  }, []);

  const handleChangePlanta = useCallback((value) => {
    setSelectedOptionPla(!value ? null : value);
  }, []);

  const handleChangeOt = useCallback((value) => {
    setSelectedOptionOt(!value ? null : value);
  }, []);

  const handleChangeEquipo = useCallback((value) => {
    setSelectedOptionEquipo(!value ? null : value);
  }, []);

  const handleBuscador = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  const handleDeleteMuestra = (id) => {
    setModalStatus2(false);
    deleteMuestra(id).then(() => {
      setMuestraId("");
      let paginaActualTemp = paginaActual;
      if (muestras.length === 1 && paginaActualTemp > 1) {
        paginaActualTemp = paginaActualTemp - 1;
        setPaginaActual(paginaActualTemp);
      }

      return fetchMuestrasAllFilters(
        paginaActual,
        orderBy,
        searchTerm,
        "delete",
        selectedOptionCli === null ? "" : selectedOptionCli.value,
        selectedOptionPla === null ? "" : selectedOptionPla.value,
        selectedOptionOt === null ? "" : selectedOptionOt.value,
        selectedOptionEquipo === null ? "" : selectedOptionEquipo.value,
        sinDiagnostico,
        sinEstado,
        sinFechaAnalisis,
        sinImagenes,
        sinResultados,
        sinSugerencias
      );
    });
  };

  const handleChangeCheckBox = useCallback((nombre, value) => {
    const setters = {
      'sinDiagnostico': setSinDiagnostico,
      'sinEstado': setSinEstado,
      'sinFechaAnalisis': setSinFechaAnalisis,
      'sinImagenes': setSinImagenes,
      'sinResultados': setSinResultados,
      'sinSugerencias': setSinSugerencias,
    };

    if (nombre === "todos") {
      Object.values(setters).forEach(setter => setter(value));
    } else {
      setters[nombre](value);
    }
  }, []);

  const cargarCheckbox = useCallback((nameCheck) => {
    if (nameCheck === "sinDiagnostico" && sinDiagnostico === true) return true;
    else if (nameCheck === "sinEstado" && sinEstado === true) return true;
    else if (nameCheck === "sinFechaAnalisis" && sinFechaAnalisis === true) return true;
    else if (nameCheck === "sinImagenes" && sinImagenes === true) return true;
    else if (nameCheck === "sinResultados" && sinResultados === true) return true;
    else if (nameCheck === "sinSugerencias" && sinSugerencias === true) return true;
    else return false;
  }, [sinDiagnostico, sinEstado, sinFechaAnalisis, sinImagenes, sinResultados, sinSugerencias]);

  // Function to clear cache when needed
  const clearCache = useCallback(() => {
    apiCache.clear();
  }, []);


  const datosOrdenDeTrabajo = {
    page: datos?.page,
    modalStatus: true,
    id: datos?.id,
    clienteId: datos?.clienteId,
    plantaId: datos?.plantaId,
    estadoComp: {
      id: datos?.estadoComp?.id,
      accion_ef_ot: datos?.estadoComp?.accion_ef_ot,
      final_sn_ef_ot: datos?.estadoComp?.final_sn_ef_ot,
      color_ef_ot: datos?.estadoComp?.color_ef_ot,
      desc_ef_ot: datos?.estadoComp?.desc_ef_ot,
    },
    codigo: datos?.codigo,
    cliente: datos?.cliente,
    fechaProgramada: datos?.fechaProgramada,
    lote: datos?.lote
  };
  return (
    <Styled>

      <Preloader
        title="Cargando..."
        subtitle={"Espere unos Segundos por favor..."}
        loading={isLoading}
      />

      <div classname="toast">
        {success ? (
          <Toast key={key} title={msjToast} close={() => setSuccess(false)} />
        ) : null}
        {error ? (
          <Toast
            key={key}
            type={"error"}
            title={msjToast}
            close={() => setError(false)}
          />
        ) : null}
      </div>

      <Modal
        datos={datosModal}
        isOpen={statusModal}
        type={typeModal}
        onClose={({ msj, status }) => {
          setSuccess(false);
          setError(false);
          if (status === "success") {
            setKey(key + 1);
            // Si se creó una muestra o se crearon muestras exitosamente, volver a la primera página
            if (msj.includes("cread") || msj.includes("Muestras creadas exitosamente")) {
              setPaginaActual(1);
              // Llamar a fetchMuestrasAllFilters con página 1 inmediatamente
              fetchMuestrasAllFilters(
                1,
                orderBy,
                searchTerm,
                "new",
                selectedOptionCli === null ? "" : selectedOptionCli.value,
                selectedOptionPla === null ? "" : selectedOptionPla.value,
                selectedOptionOt === null ? "" : selectedOptionOt.value,
                selectedOptionEquipo === null ? "" : selectedOptionEquipo.value,
                sinDiagnostico,
                sinEstado,
                sinFechaAnalisis,
                sinImagenes,
                sinResultados,
                sinSugerencias
              );
            } else {
              if (msj !== "Diagnostico") setSuccess(true);
              if (msj !== "Diagnostico") setMsjToast(msj);
              fetchMuestrasAllFilters(
                paginaActual,
                orderBy,
                searchTerm,
                "",
                selectedOptionCli === null ? "" : selectedOptionCli.value,
                selectedOptionPla === null ? "" : selectedOptionPla.value,
                selectedOptionOt === null ? "" : selectedOptionOt.value,
                selectedOptionEquipo === null ? "" : selectedOptionEquipo.value,
                sinDiagnostico,
                sinEstado,
                sinFechaAnalisis,
                sinImagenes,
                sinResultados,
                sinSugerencias
              );
            }
          } else if (status === "error") {
            // setKey(key + 1);
            setError(true);
            setMsjToast(msj);
          } else if (status === "cancel") {
            fetchMuestrasAllFilters(
              paginaActual,
              orderBy,
              searchTerm,
              "",
              selectedOptionCli === null ? "" : selectedOptionCli.value,
              selectedOptionPla === null ? "" : selectedOptionPla.value,
              selectedOptionOt === null ? "" : selectedOptionOt.value,
              selectedOptionEquipo === null ? "" : selectedOptionEquipo.value,
              sinDiagnostico,
              sinEstado,
              sinFechaAnalisis,
              sinImagenes,
              sinResultados,
              sinSugerencias
            );
          }
          setModalStatus(false);
        }}
      />
      <StyledTypography>Muestras</StyledTypography>
      {datos &&

        < CustomButton
          label={"Volver a la orden de trabajo"}
          startIcon={<ArrowBackIcon />}
          variant="contained"
          className="buttonColorTable"
          size="medium"
          onClick={() => {
            // setTypeModal("ordenesTrabajo");
            // setDatosModal({
            //   button: "controlpanel", datos: {
            //     id: datos?.id,
            //     clienteId: datos?.clienteId,
            //     plantaId: datos?.plantaId,
            //     estadoComp: {
            //       id: datos?.estadoComp?.id,
            //       accion_ef_ot: datos?.estadoComp?.accion_ef_ot,
            //       final_sn_ef_ot: datos?.estadoComp?.final_sn_ef_ot,
            //       color_ef_ot: datos?.estadoComp?.color_ef_ot,
            //       desc_ef_ot: datos?.estadoComp?.desc_ef_ot,
            //     },
            //     codigo: datos?.codigo,
            //     cliente: datos?.cliente,
            //     fechaProgramada: datos?.fechaProgramada,
            //     lote: datos?.lote
            //   }
            // });
            // setModalStatus(true);
            navigate("/muestras/ordenesdetrabajo",
              { state: datosOrdenDeTrabajo });
          }}
        />
      }
      <BoxHeader>

        <BoxInputs>
          {token.clienteId === "" ?
            <Input
              isClearable
              reactSelect
              options={clientes}
              stylesHeader
              onChange={(e) => {
                handleChangeCliente(e);
              }}
              placeholder={"Seleccione el cliente"}
              value={selectedOptionCli ? selectedOptionCli : null}

            /> : null}
          {(token.plantaId === ""
            || token.plantaId.split(",").length > 1) ? (
            <Input
              isClearable
              reactSelect
              options={plantas}
              stylesHeader
              onChange={(e) => {
                handleChangePlanta(e);
              }}
              value={selectedOptionPla}
              placeholder={
                selectedOptionCli === null
                  ? "Seleccione el cliente primero"
                  : "Seleccione la Planta"
              }
              isDisabled={selectedOptionCli === null}
              showSubLabel
            />) : null}
          <Input
            isClearable
            reactSelect
            options={ordenTrabajo}
            stylesHeader
            onChange={(e) => {
              handleChangeOt(e);
            }}
            value={selectedOptionOt}
            placeholder={
              selectedOptionCli === null ? "Seleccione el cliente primero" : "Seleccione la OT"
            }
            isDisabled={selectedOptionCli === null}
            showSubLabel={true}

          />
          <Input
            isClearable
            reactSelect
            options={equipo}
            stylesHeader
            onChange={(e) => {
              handleChangeEquipo(e);
            }}
            value={selectedOptionEquipo}
            placeholder={
              selectedOptionCli === null
                ? "Seleccione el cliente primero"
                : "Seleccione el Equipo"
            }
            isDisabled={selectedOptionCli === null}
            showSubLabel
          />
          <Input
            inputProp={true}
            positionIcon={"start"}
            placeholder={"Buscar por número"}
            icon={<Search />}
            size={"small"}
            search={"true"}
            className={"inputSelect"}
            value={searchTerm}
            isClearable={() => setSearchTerm("")}
            onChange={(e) => handleBuscador(e.target.value)}
            type={"number"}
          />
        </BoxInputs>
        <CustomButton
          label={"Nueva muestra"}
          startIcon={<RenderImgStyled img={More} />}
          variant={"contained"}
          className="buttonHeaderTable"
          onClick={(e) => {
            handleClickButtonHeader(e);
          }}
        />
      </BoxHeader>

      <BoxSubHeader>
        <Box>
          {datosCheckBox?.map((res, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={cargarCheckbox(res.name)}
                  onChange={(e) => handleChangeCheckBox(res.name, e.target.checked)}
                />
              }
              label={res.label}
              sx={{
                '& .MuiFormControlLabel-label':
                {
                  fontSize: '16px',
                  fontFamily: fonts.primary,
                  fontWeight: 400, lineHeight: "150%",
                  color: colors.darkGrayDos
                }
              }}
            />
          ))}

        </Box>
        <Box>
          <CustomButton
            label={"Muestras"}
            startIcon={<RenderImgStyled img={Print} />}
            variant={"contained"}
            className="buttonColorTable"
            onClick={() => {
              handleImprimirMuestras();
            }}
          />
          <CustomButton
            label={"Resumen"}
            startIcon={<RenderImgStyled img={Print} />}
            variant={"contained"}
            className="buttonColorTable"
            onClick={() => {
              handleImprimirResumen();
            }}
          />
        </Box>
      </BoxSubHeader>
      <Box sx={{ display: "flex", gap: "10px" }}>
        <RenderImg img={SetIcon} alt="skf" className="img" />
        <Typography
          sx={{
            fontFamily: fonts.primary,
            "&:hover": { textDecoration: "underline" },
            cursor: "pointer",
            color: colors.steelBlue,
            fontWeight: "400",
          }}
          onClick={() => {
            setSearchTerm("")
            setSelectedOptionCli(null)
            setSelectedOptionPla(null)
            setSelectedOptionOt(null)
            setSelectedOptionEquipo(null)
            setSinDiagnostico(null)
            handleChangeCheckBox("todos", false)
            clearCache() // Clear cache when filters are reset
          }}
        >
          Limpiar filtros
        </Typography>
      </Box>
             <Tables
         key={`tables-${key}-${paginaActual}`}
         typeTable={"prop"}
         columns={columns}
         rows={muestras}
         cRows={20}
         totalRows={itemsCount}
         actualpage={paginaActual}
         pagination={true}
         onClickSwitch={(value) => {
           handleOrder(value);
         }}
         page={(e) => setPaginaActual(e + 1)}
         pages={pageCount}
         buttons={buttonsMuestras}
         onClickButtonTable={(value, valuesRow) => {
           
           if (value === "Imprimir") {
             handleImprimirMuestraEspecifica([valuesRow.id], valuesRow.codigo)
           } else {
             handleClickButtonTable(value, valuesRow);
           }
         }}
       />

      <Modal2
        type="eliminar"
        isOpen={statusModal2}
        onClose={() => setModalStatus2(false)}
        onClickSuccess={() => {
          handleDeleteMuestra(muestraId);
        }}
      />
    </Styled>
  );
};

export default Muestras;
// useEffect(() => {
//   fetchMuestrasAllFilters(
//     paginaActual,
//     orderBy,
//     searchTerm,
//     "changeCheckBox",
//     selectedOptionCli === null ? "" : selectedOptionCli.value,
//     selectedOptionPla === null ? "" : selectedOptionPla.value,
//     selectedOptionOt === null ? "" : selectedOptionOt.value,
//     selectedOptionEquipo === null ? "" : selectedOptionEquipo.value,
//     sinDiagnostico,
//     sinEstado,
//     sinFechaAnalisis,
//     sinImagenes,
//     sinResultados,
//     sinSugerencias
//   );
// }, [sinDiagnostico, sinEstado, sinFechaAnalisis, sinImagenes, sinResultados, sinSugerencias]);
// useEffect(() => {
//   if (!clientes.length) {
//     getClienteOptions().then((res) => {
//       setClientes([]);
//       res.data.forEach((res) => {
//         setClientes((prevClientes) => {
//           return [...prevClientes, { label: res.desc_cli, value: res.id }];
//         });

//         if (token.idCliente !== "" && res.id === parseInt(token.clienteId, 10)) {
//           setSelectedOptionCli({
//             label: res.desc_cli,
//             value: res.id
//           })

//           getPlantabyCliente2(res.id).then((res) => {
//             setPlantas([]);  // Limpiar plantas antes de actualizar

//             res.data.forEach((res) => {
//               // Chequeo para token.plantaId
//               if (token.plantaId === "") {
//                 // Caso 1: Si token.plantaId es vacío, continua normal
//                 setPlantas((prevPlantas) => [...prevPlantas, { label: res.desc_pla, value: res.id }]);
//               } else if (token.plantaId.split(",").length === 1) {
//                 // Caso 2: Si token.plantaId es un único número
//                 if (token.plantaId === res.id.toString()) {
//                   setSelectedOptionPla({ label: res.desc_pla, value: res.id });
//                   setPlantas((prevPlantas) => [...prevPlantas, { label: res.desc_pla, value: res.id }]);
//                 }
//               } else {
//                 // Caso 3: Si token.plantaId es una secuencia de números
//                 const plantaIds = token.plantaId.split(",").map(id => id.trim());
//                 if (plantaIds.includes(res.id.toString())) {
//                   setPlantas((prevPlantas) => [...prevPlantas, { label: res.desc_pla, value: res.id }]);
//                 } else {
//                   setPlantas((prevPlantas) => [...prevPlantas]); // Mantener el set anterior si no coincide
//                 }
//               }

//               if (idPla && idPla.toString() === res.id.toString()) {
//                 setSelectedOptionPla({
//                   label: res.desc_pla,
//                   value: res.id,
//                 });
//               }
//             });
//           });

//           getAllOrdenByClienteOptions(res.id).then((res) => {
//             setOrdenTrabajo([]);
//             res.data.forEach((res) => {
//               if (idOt && idOt.toString() === res.id.toString()) {
//                 setSelectedOptionOt({
//                   label: res.desc_otra,
//                   value: res.id,
//                 });
//               }
//               setOrdenTrabajo((prevOrdenTrabajo) => {
//                 return [...prevOrdenTrabajo, { label: res.desc_otra, value: res.id }];
//               });
//             })
//           });

//           getAllEquipoByClienteOptions(res.id).then((res) => {
//             setEquipo([]);
//             res.data.forEach((res) => {
//               if (idEqui && idEqui.toString() === res.id.toString()) {
//                 setSelectedOptionEquipo({
//                   label: res.desc_equi,
//                   value: res.id,
//                 });
//               }
//               setEquipo((prevEquipo) => {
//                 return [...prevEquipo, { label: res.desc_equi, value: res.id }];
//               });
//             });
//             setIsLoading(false);
//           });
//         }

//         if (idCli && idCli.toString() === res.id.toString()) {
//           setSelectedOptionCli({
//             label: res.desc_cli,
//             value: res.id,
//           });

//           getPlantabyCliente2(idCli).then((res) => {
//             setPlantas([]);
//             res.data.forEach((res) => {
//               if (idPla && idPla.toString() === res.id.toString()) {
//                 setSelectedOptionPla({
//                   label: res.desc_pla,
//                   value: res.id,
//                 });
//               }
//               setPlantas((prevPlantas) => {
//                 return [...prevPlantas, { label: res.desc_pla, value: res.id }];
//               });
//             })
//           });

//           getAllOrdenByClienteOptions(idCli).then((res) => {
//             setOrdenTrabajo([]);
//             res.data.forEach((res) => {
//               if (idOt && idOt.toString() === res.id.toString()) {
//                 setSelectedOptionOt({
//                   label: res.desc_otra,
//                   value: res.id,
//                 });
//               }
//               setOrdenTrabajo((prevOrdenTrabajo) => {
//                 return [...prevOrdenTrabajo, { label: res.desc_otra, value: res.id }];
//               });
//             })
//           });

//           getAllEquipoByClienteOptions(idCli).then((res) => {
//             setEquipo([]);
//             res.data.forEach((res) => {
//               if (idEqui && idEqui.toString() === res.id.toString()) {
//                 setSelectedOptionEquipo({
//                   label: res.desc_equi,
//                   value: res.id,
//                 });
//               }
//               setEquipo((prevEquipo) => {
//                 return [...prevEquipo, { label: res.desc_equi, value: res.id }];
//               });
//             });
//             setIsLoading(false);
//           });
//         }
//       })
//     });

//   }

//   fetchMuestrasAllFilters(
//     paginaActual,
//     orderBy,
//     searchTerm,
//     "primera",
//     idCli || selectedOptionCli?.value,
//     idPla || selectedOptionPla?.value,
//     idOt || selectedOptionOt?.value,
//     idEqui || selectedOptionEquipo?.value,
//     sinDiagnostico,
//     sinEstado,
//     sinFechaAnalisis,
//     sinImagenes,
//     sinResultados,
//     sinSugerencias
//   );

//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [paginaActual, orderBy]);
// useEffect(() => {
//   fetchMuestrasAllFilters(
//     paginaActual,
//     orderBy,
//     searchTerm,
//     "search",
//     selectedOptionCli?.value || "",
//     selectedOptionPla?.value || "",
//     selectedOptionOt?.value || "",
//     selectedOptionEquipo?.value || "",
//     sinDiagnostico,
//     sinEstado,
//     sinFechaAnalisis,
//     sinImagenes,
//     sinResultados,
//     sinSugerencias
//   );
// }, [
//   searchTerm,
//   selectedOptionCli,
//   selectedOptionPla,
//   selectedOptionOt,
//   selectedOptionEquipo,
//   sinDiagnostico,
// ]);

